import React, { VFC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Link, makeStyles } from '@dxb-web-ui-framework/design-system';
import { invokeService } from '@dxb-web-ui-framework/common/hooks/DataService';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { isEmpty } from '@dxb-web-ui-framework/common/utils';
import { useWizardErrorState } from '../../../../../../../contexts/ClientSideWizard/hooks';
import { IAuthorizationsService } from '../../../../../../../../../iam/src/domain/Authorizations/entities/IAuthorizationsService';

export interface ResendOTPCodeButtonProps {
  externalEffectCallbacks: {
    authorizationsService: IAuthorizationsService;
    authorizationId: number;
  };
}

const useStyles = makeStyles(theme => ({
  linkBtn: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const ResendOTPCodeButton: VFC<ResendOTPCodeButtonProps> = ({ externalEffectCallbacks }) => {
  const { t } = useTranslation();
  const { isExtraSmallScreen: isMobile } = useScreenDetector();

  const wizardErrorState = useWizardErrorState();

  const { authorizationsService, authorizationId } = externalEffectCallbacks;

  const onResendCode = useCallback(async () => {
    if (!isEmpty(wizardErrorState.errors)) {
      await wizardErrorState.setNetworkCallErrors(null);
    }
    const { error } = await invokeService(() => authorizationsService.ResendCode({ authorizationId }));
    if (error) {
      wizardErrorState.setNetworkCallErrors(error);
      return;
    }
  }, [authorizationsService, wizardErrorState, authorizationId]);

  const classes = useStyles();

  return (
    <Box mt={2} display='flex' justifyContent={isMobile ? 'flex-end' : 'flex-start'} alignContent='center'>
      <Link size='small' onClick={onResendCode} classes={{ root: classes.linkBtn }}>
        {t('content-composer.components.InApp2FA.InApp2FAMethods.OTP.ResendOTPCodeButton.Text')}
      </Link>
    </Box>
  );
};

export { ResendOTPCodeButton };
